import { Box, ButtonBase, Card, Typography } from "@mui/material"
import { Else, If } from "lib/@components/switch"
import { getFolderTilePresentation } from "./folder-tile-presentation"
import { useEffect, useRef, useState } from "react"

export function FolderTile({ item, onClick }) {
    const [failedImage, setFailedImage] = useState()
    const [loadedImage, setLoadedImage] = useState()
    const imageContainerRef = useRef()
    const imageRef = useRef()
    const presentation = getFolderTilePresentation(item, failedImage, loadedImage)
    useEffect(checkImageAfterRender, [item.data?.image])

    return (
        <ButtonBase
            color="primary"
            sx={{ flex: presentation.buttonFlex, width: 1, display: "flex", flexDirection: "column" }}
            aria-label={`Choose ${item.label}`}
            onClick={onClick}
        >
            <Card
                data-cy={`folder-card-${item.label?.toLowerCase().split(" ").join("-")}`}
                sx={{
                    width: 1,
                    textAlign: "center",
                    cursor: "pointer",
                    flex: presentation.buttonFlex,
                    alignSelf: "stretch",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    pb: presentation.cardPaddingBottom,
                    transition: presentation.transition,
                }}
            >
                <If truthy={presentation.variant === "image"}>
                    <Box width={1} sx={{ position: "relative" }} ref={imageContainerRef}>
                        <Box
                            width={1}
                            component="img"
                            border="none"
                            ref={imageRef}
                            onError={handleImageError}
                            onLoad={handleImageLoad}
                            sx={{
                                objectFit: "cover",
                                opacity: presentation.imageOpacity,
                                transition: presentation.transition,
                            }}
                            src={item.data?.image}
                            bgcolor={presentation.accentColor}
                            height={presentation.accentLineHeight}
                            color="#333"
                            overflow="hidden"
                        />
                    </Box>
                    <Else>
                        <Box sx={{ height: presentation.accentLineHeight, bgcolor: presentation.accentColor }} />
                    </Else>
                </If>
                <Box sx={{ px: 2, py: presentation.contentPaddingY }}>
                    <Typography
                        variant="subtitle1"
                        sx={{ mt: presentation.titleMarginTop, transition: presentation.transition }}
                    >
                        {item.label ?? "Not named"}
                    </Typography>
                </Box>
            </Card>
        </ButtonBase>
    )

    function handleImageError() {
        setFailedImage(item.data?.image)
        setLoadedImage()
    }

    function handleImageLoad(event) {
        markImageLoadedWhenUsable(event.currentTarget)
    }

    function checkImageAfterRender() {
        if (!item.data?.image) return undefined
        checkLoadedImage()
        const interval = setInterval(checkLoadedImage, 250)
        const timeout = setTimeout(stopCheckingImage, 15000)
        return cleanUpImageCheck

        function stopCheckingImage() {
            clearInterval(interval)
        }

        function cleanUpImageCheck() {
            clearInterval(interval)
            clearTimeout(timeout)
        }
    }

    function checkLoadedImage() {
        const image = imageRef.current ?? imageContainerRef.current?.querySelector("img")
        if (!image?.complete) return
        markImageLoadedWhenUsable(image)
    }

    function markImageLoadedWhenUsable(image) {
        if (image.naturalWidth > 0 && image.naturalHeight > 0) {
            setLoadedImage(item.data?.image)
            return
        }
        setFailedImage(item.data?.image)
        setLoadedImage()
    }
}
